export default "__VITE_PUBLIC_ASSET__392493b1__"